/**
 * Server mirror: `src/shared/subscriptionAdminPreview.ts` — keep helpers aligned.
 *
 * When true on `subscription.features`, feature gates ignore the subscription's
 * product-preview entitlement so admin can preview subscriber-only behavior.
 * Admin authorization is independent and is checked by Express against Postgres.
 */
export const PREVIEW_NON_ADMIN_FEATURES_KEY = "previewNonAdminFeatures" as const;

export type SubscriptionFeaturesPreview = Record<string, boolean | undefined> | null | undefined;

export function effectiveAdminForFeatures(admin: boolean, features: SubscriptionFeaturesPreview): boolean {
  if (!admin) return false;
  return !features?.[PREVIEW_NON_ADMIN_FEATURES_KEY];
}
